import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahPreOrder = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noPreOrder, setNoPreOrder] = useState("");
  const [tipePreOrder, setTipePreOrder] = useState("");
  const [tanggalPreOrder, setTanggalPreOrder] = useState(new Date());
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState(null);
  const [keteranganPreOrder, setKeteranganPreOrder] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let tipePreOrderOptions = [
    {
      label: "PROD",
    },
    {
      label: "REV. PROD",
    },
  ];

  useEffect(() => {
    getPreOrderById();
  }, []);

  const getPreOrderById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/preOrders/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoPreOrder(response.data.noPreOrder);
    setTipePreOrder(response.data.tipePreOrder);
    setTanggalPreOrder(new Date(response.data.tanggalPreOrder));
    setNoRab(response.data.rab.noRab);
    setTanggalDpRab(new Date(response.data.rab.tanggalDpRab));
    setKeteranganPreOrder(
      response.data.keteranganPreOrder.toLocaleString("en-US")
    );
    setLoading(false);
  };

  const updatePreOrder = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      tipePreOrder.length !== 0 &&
      tanggalPreOrder !== null
    ) {
      setLoading(true);
      await postRequest(
        `/updatePreOrder/${id}`,
        {
          tipePreOrder,
          tanggalPreOrder,
          keteranganPreOrder,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate(`/daftarPreOrder/preOrder/${id}`);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah PO</h5>
      <hr />
      <Card>
        <Card.Header>PO</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updatePreOrder}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode PO :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noPreOrder}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tipe <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={tipePreOrderOptions}
                      renderInput={(params) => (
                        <TextField required size="small" {...params} />
                      )}
                      value={tipePreOrder}
                      onChange={(e, value) => {
                        if (value) {
                          setTipePreOrder(value.label);
                        } else {
                          setTipePreOrder("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. PO <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalPreOrder}
                      customInput={<Form.Control required />}
                      onChange={(date) => setTanggalPreOrder(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      disabled
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalDpRab}
                      customInput={<Form.Control disabled />}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      style={{ textTransform: "uppercase" }}
                      as="textarea"
                      rows={4}
                      value={keteranganPreOrder}
                      onChange={(e) => {
                        setKeteranganPreOrder(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(`/daftarPreOrder/preOrder/${id}`)}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahPreOrder;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const colorRed = {
  color: "red",
};
